import { render } from "./PointCard.vue?vue&type=template&id=0dddb13b&scoped=true"
import script from "./PointCard.vue?vue&type=script&lang=js"
export * from "./PointCard.vue?vue&type=script&lang=js"

import "./PointCard.vue?vue&type=style&index=0&id=0dddb13b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_96a7004b96defd358d2378707b0c7ba6/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dddb13b"]])

export default __exports__